export default __webpack_public_path__ + "media/images/avatar-f758c86c6d27b48d9867646fb26d322a.jpg";